<template>
  <div class="child_information_edit">
    <div class="child_information_edit_form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="child_information_edit_ruleForm">
        <div class="child_information_edit_ruleForm_readonly">
          <div class="child_information_edit_ruleForm_box first">
            <div class="child_information_edit_ruleForm_label span3">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>头</span>
                  <span>像</span>
                </span>
              </span>
              <van-uploader :after-read="afterRead" accept="image/jpg, image/jpeg">
                <img :src="headImg" class="child_information_edit_ruleForm_label_pic">
              </van-uploader>
            </div>
            <div class="child_information_edit_ruleForm_label span4">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>姓</span>
                  <span>名</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_studentName">{{studentName}}</span>
            </div>
            <div class="child_information_edit_ruleForm_label span3">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>性</span>
                  <span>别</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_sex">{{sex}}</span>
            </div>
          </div>
          <div class="child_information_edit_ruleForm_box">
            <div class="child_information_edit_ruleForm_label span3">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>年</span>
                  <span>龄</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_age">{{age}}</span>
            </div>
            <div class="child_information_edit_ruleForm_label span4">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>出</span>
                  <span>生</span>
                  <span>日</span>
                  <span>期</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_birthday">{{birthday}}</span>
            </div>
            <div class="child_information_edit_ruleForm_label span3">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>与</span>
                  <span>家</span>
                  <span>长</span>
                  <span>关</span>
                  <span>系</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_relationShip">{{relation}}</span>
            </div>
          </div>
          <div class="child_information_edit_ruleForm_box">
            <div class="child_information_edit_ruleForm_label idCard">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>身</span>
                  <span>份</span>
                  <span>证</span>
                  <span>号</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_idCard">{{idCard}}</span>
            </div>
            <div class="child_information_edit_ruleForm_label school">
              <span class="child_information_edit_ruleForm_label_name">
                <span class="edit_ruleForm_label">
                  <span>学</span>
                  <span>校</span>
                </span>
              </span>:
              <span class="child_information_edit_ruleForm_label_school">{{school}}</span>
            </div>
          </div>
        </div>
        <div class="child_information_edit_ruleForm_default">
          <el-form-item prop="signs" class="child_information_edit_ruleForm_default_inline signs">
            <span slot="label" class="edit_ruleForm_label">
              <span>星</span>
              <span>座</span>
            </span>
            <div class="child_information_edit_ruleForm_default_inline_signs">
              <select-box :inputValue="ruleForm.signs" :options="signsOption" @selectChange="signsChange"></select-box>
            </div>
          </el-form-item>
          <el-form-item prop="nickName" class="child_information_edit_ruleForm_default_inline nickName">
            <span slot="label" class="edit_ruleForm_label">
              <span>昵</span>
              <span>称</span>
            </span>
            <el-input v-model="ruleForm.nickName"></el-input>
          </el-form-item>
          <el-form-item prop="classes" class="child_information_edit_ruleForm_default_block classes">
            <span slot="label" class="edit_ruleForm_label">
              <span>班</span>
              <span>级</span>
            </span>
            <span class="ruleForm_default_inline_genderNo">
              <select-box :inputValue="ruleForm.genderNo" :options="genderOption" @selectChange="genderChange"></select-box>
            </span>
            <span class="ruleForm_default_inline_genderName">年</span>
            <span class="ruleForm_default_inline_classNameNo">
              <select-box :inputValue="ruleForm.classNameNo" :options="classOption" @selectChange="classChange"></select-box>
            </span>
            <span class="ruleForm_default_inline_className">班</span>
          </el-form-item>
          <el-form-item prop="province" class="child_information_edit_ruleForm_default_block">
            <span slot="label" class="edit_ruleForm_label">
              <span>所</span>
              <span>在</span>
              <span>地</span>
            </span>
            <span class="ruleForm_default_block_province" @click="editAddress">
              <el-input v-model="province" readonly></el-input>
              <i class="ruleForm_default_block_name">省</i>
            </span>
            <span class="ruleForm_default_block_city" @click="editAddress">
              <el-input v-model="city" readonly></el-input>
              <i class="ruleForm_default_block_name">市</i>
            </span>
            <span class="ruleForm_default_block_county" @click="editAddress">
              <el-input v-model="county" readonly></el-input>
              <i class="ruleForm_default_block_name">区/县</i>
            </span>
          </el-form-item>
          <el-form-item prop="personalSignature" class="child_information_edit_ruleForm_default_block">
            <span slot="label" class="edit_ruleForm_label">
              <span>个</span>
              <span>性</span>
              <span>签</span>
              <span>名</span>
            </span>
            <el-input v-model="ruleForm.personalSignature" placeholder="请输入个性签名" class="ruleForm_default_block_personalSignature"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="ruleForm_block_btns">
      <span class="ruleForm_block_btns_add" @click="onSave">保存</span>
    </div>
    <!-- 地址 -->
    <van-popup v-model="showPicker" round position="bottom" @click.stop>
      <van-area title="选择所在地" :area-list="areaList" :columns-num="3" :value="showCode" :is-horizontal="true" @cancel="showPicker = false" @confirm="onAreaConfirm"></van-area>
    </van-popup>
  </div>
</template>

<script>
  import selectBox from './select-box.vue';
  import { _upload } from '../../api/family-archives';
  import { areaList } from '@vant/area-data';
  import { _getList, _getSigns, _saveChild } from '../../api/children-file';
  import BScroll from "better-scroll";
  export default {
    name:"edit-basic-information",
    props: {
      componentData: {
        type: Object
      }
    },
    components: {
      selectBox
    },
    data() {
      return {
        ruleForm: {
          signs: "", // 星座
          nickName: "", // 昵称
          classes: "",//班级
          gender: '',// 年级
          genderNo: "", // 年级code
          className: '',// 班级名称
          classNameNo: "", // 班级
          personalSignature: "", // 个性签名
        },
        province: "", // 省
        city: "", // 市
        county: "", // 区
        showCode: '',// 默认显示哪个地区code
        areaList, // 省市区数据
        headImg: require('../../assets/images/head/boy.png'), // 头像
        studentName: "", // 姓名
        sex: "", // 性别
        age: "", // 年龄
        birthday: "", // 出生日期
        relation: '',// 家长的关系名称
        relationShip: "", // 与家长的关系
        idCard: "", // 处理过展示的身份证号
        idCardCopy: '', // 身份证号
        school: "",// 学校
        schoolNo: '', // 学校code
        currentDate: new Date(),//日期
        signsOption: [], // 星座
        genderOption: [],// 年级
        classOption: [],// 班级
        addressColumn: [],// 地址
        showPicker: false, // 默认不展示地域弹框
        pic: "", // 头像
        rules: {
          nickName: [{ min: 0, max: 6, message: '昵称最多支持6个字符', trigger: 'blur' }]
        },
      }
    },
    watch: {
      componentData: {
        handler(data) {
          let ruleForm = data.basicData;
          if (Object.keys(ruleForm).length > 0) {
            if (ruleForm.headImg) {
              // this.headImg =  'http://' + location.host + '/' + ruleForm.headImg;
              this.headImg = ruleForm.headImg;
              this.pic = ruleForm.headImg;
            } else {
              this.headImg = ruleForm.sex == 1 ? require('../../assets/images/head/boy.png') : require('../../assets/images/head/girl.png');
              this.pic = "";
            }
            this.studentName = ruleForm.studentName; // 学生姓名
            this.sex = ruleForm.sex == 1 ? '男' : '女';
            this.age = ruleForm.age; // 年龄
            this.birthday = ruleForm.birthday; // 出生日期
            this.relationShip = ruleForm.relationNo; // 与家长关系
            this.relation = ruleForm.relation; // 与家长关系
            this.idCardCopy = ruleForm.idCard; // 身份证号
            this.idCard = this.idCardCopy ? this.idCardCopy.replace(/^(.{6})(?:\d+)(.{3})$/, "\$1*********\$2") : '';
            this.school = ruleForm.school; // 学校
            this.schoolNo = ruleForm.schoolNo; // 学校code
            this.ruleForm.signs = ruleForm.signs && ruleForm.signs.name || ""; // 星座
            this.ruleForm.nickName = ruleForm.nickName; // 昵称
            this.ruleForm.genderNo = ruleForm.genderNo; // 年级
            this.ruleForm.gender = ruleForm.gender; // 年级
            this.ruleForm.classNameNo = ruleForm.classNameNo;  // 班级
            this.ruleForm.className = ruleForm.className;  // 班级
            this.province = ruleForm.province; // 省
            this.city = ruleForm.city; // 市
            this.county = ruleForm.county; // 区，县
            this.ruleForm.personalSignature = ruleForm.personalSignature; // 个性签名
          }

        },
        immediate: true,
        deep: true
      },
    },
    created() {
      // 年级字典
      _getList('grade').then(res => {
        if (res.code == 200) {
          let dataList = res.data;
          dataList.map(item => {
            this.genderOption.push({ label: item.name, value: item.code })
          })
        } else {
          Toast({ message: res.message, className: 'rotation' })
        }
      })
      // 班级
      _getList('class').then(res => {
        if (res.code == 200) {
          let dataList = res.data;
          dataList.map(item => {
            this.classOption.push({ label: item.name, value: item.code })
          })
        } else {
          Toast({ message: res.message, className: 'rotation' })
        }
      })
      // 星座
      _getSigns().then(res => {
        if (res.code == 200) {
          this.signsOption = res.data;
        } else {
          Toast({ message: res.message, className: 'rotation' })
        }
      })
    },
    mounted() {
      this.$nextTick(() => {
        let bs = new BScroll('.child_information_edit_form', {
          pullUpLoad: true, // 不触发上拉事件
          scrollbar: true, // 展示滚动条
          pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
          scrollX: false, // 关闭横向滚动功能
          quadrant: 2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
          click: true, // 开启点击事件
          bounce: false, // 关闭滚动到边缘时的回弹动作
          stopPropagation: true // 阻止事件冒泡,内部滑动禁止外部滑动
        })
      })
    },
    methods: {
      // 图片读取完后的回调函数
      afterRead(file) {
        const data = new FormData()
        data.append('file', file.file)
        _upload(data).then((res) => {
          if (res.code == '200') {
            this.headImg = file.content;
            this.pic = res.data;
          } else {
            Toast({ message: res.message, className: 'rotation' });
          }
        })
      },
      // 编辑地址
      editAddress() {
        this.showPicker = true;
        // 解决滚动条transfrom对定位的影响
        document.getElementsByClassName('child_information_edit_ruleForm')[0].style.transform = 'none';
        document.getElementsByClassName('bscroll-indicator')[0].style.transform = 'none';
        // this.$emit('editAddress')
      },
      // 地狱弹框的确认
      onAreaConfirm(e) {
        this.province = e[0].name;
        this.city = e[1].name;
        this.county = e[2].name;
        this.showPicker = false
      },
      // 保存
      onSave() {
        let params = {
          id: this.componentData.studentId, // 主键id
          headImg: this.pic, // 头像
          studentName: this.studentName, // 学生姓名
          nickName: this.ruleForm.nickName, // 学生昵称
          sex: this.sex == '男' ? 1 : 2, // 学生性别
          school: this.school, // 学校名称 name
          schoolNo: this.schoolNo,//  code
          gender: this.ruleForm.gender,// 年级名称
          genderNo: this.ruleForm.genderNo, // 年级
          className: this.ruleForm.className,
          classNameNo: this.ruleForm.classNameNo, // 班级
          idCard: this.idCardCopy, // 身份证
          birthday: this.birthday, // 生日
          age: this.age, // 年龄
          signs: this.ruleForm.signs || null, // 星座
          province: this.province, // 省
          city: this.city, // 市
          county: this.county, // 区
          personalSignature: this.ruleForm.personalSignature, // 个性签名
          relation: this.relation, // 与家长关系
          relationNo: this.relationShip,//
          relationOther: ''// 其他关系
        }
        _saveChild(params).then(res => {
          if (res.code == 200) {
            Toast({ message: '编辑儿童信息成功', className: 'rotation' })
          } else {
            Toast({ message: res.message, className: 'rotation' })
          }
        })
      },
      signsChange(item) {
        this.ruleForm.signs = item.value;
      },
      genderChange(item) {
        this.ruleForm.genderNo = item.value;
        this.ruleForm.gender = item.label;
      },
      classChange(item) {
        this.ruleForm.className = item.label;
        this.ruleForm.classNameNo = item.value;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .child_information_edit {
    width: 100%;
    height: 100%;
    padding: 37px 63px 80px 60px;
    // 弹框样式
    ::v-deep .van-picker__cancel {
      color: #666666;
      font-size: 16px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    ::v-deep .van-picker__confirm {
      font-size: 16px;
      color: #ff8340;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    ::v-deep .van-picker__cancel,
    ::v-deep .van-picker__confirm {
      padding: 0 30px;
    }
    ::v-deep .van-picker__title {
      font-size: 16px;
      color: #333;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    ::v-deep .van-picker-column__item {
      font-size: 14px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999;
      &.van-picker-column__item--selected {
        color: #333;
        font-weight: 500;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    ::v-deep .van-picker__frame {
      background: rgba(255, 131, 64, 0.1);
      left: 0;
      right: 0;
    }
    .child_information_edit_form {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      padding-right: 7px;
      .child_information_edit_ruleForm {
        // width:100%;
        // height:100%;
        overflow-y: auto;
        overflow-x: hidden;
        // overflow: auto;
        white-space: nowrap;
        /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/

        // &::-webkit-scrollbar {
        //    width: 8px; /*对垂直流动条有效*/
        //    border-radius: 4px;
        //    height:100px;
        //    // height: 20px; /*对水平流动条有效*/
        // }

        // /*定义滚动条的轨道颜色、内阴影及圆角*/
        // &::-webkit-scrollbar-track{
        //    // box-shadow: 0 0 3px 0 rgba(0,0,0,0.5), 1px 0 3px 0 #8E6138;
        //    background-color: #D39B5A;
        //    border-radius: 4px;
        // }
        //   &::-webkit-scrollbar-track-piece{
        //    border-radius:4px;
        // }
        // /*定义滑块颜色、内阴影及圆角*/
        // &::-webkit-scrollbar-thumb{
        //    // box-shadow: 0 0 4px 0 rgba(255,255,255,0.5),-2px 0 0 0 rgba(196,106,47,0.5);
        //    background-color: #FF8000;
        //    border-radius: 4px;
        // }
      }
      ::v-deep .bscroll-vertical-scrollbar {
        background-color: #d39b5a;
        border-radius: 4px;
        width: 8px;
        overflow: visible !important;
        opacity: 1 !important;
        z-index: 100 !important;
        .bscroll-indicator {
          background-color: #ff8000 !important;
          border-radius: 4px !important;
          border-color: #ff8000 !important;
        }
      }
      .child_information_edit_ruleForm_readonly {
        // display:flex;
        // flex-wrap: wrap;
        .child_information_edit_ruleForm_box {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 22px;
          &.first {
            margin-bottom: 8px;
            line-height: 40px;
          }
        }
        .child_information_edit_ruleForm_label {
          display: inline-block;
          color: #74410a;
          font-size: 12px;
          font-weight: 500;
          font-family: PingFangSC-Regular, PingFang SC;
          &.span3 {
            width: 30%;
          }
          &.span4 {
            width: 40%;
          }
          &.school {
            //
            width: 46.54%;
          }
          &.idCard {
            width: 52.55%;
          }
          .child_information_edit_ruleForm_label_name {
            display: inline-block;
            min-width: 48px;
            vertical-align: middle;
            .edit_ruleForm_label {
              display: flex;
              justify-content: space-between;
            }

            //    text-align: justify;
            //    -webkit-text-align:justify;
            //    text-align-last: justify;
            //    -webkit-text-align-last:justify;
            //    vertical-align:middle;
            //   -moz-text-align-last: justify;
            //    justify-content: space-between;
            //    -webkit-justify-content: space-between;
            // text-justify: distribute-all-lines;
            // text-justify: inter-ideograph;
            // font-size:12px;
            // font-family: PingFangSC-Regular, PingFang SC;
            // vertical-align: middle;
            // font-weight:500;
            //  &::after{
            //    content:"";
            //    width:100%;
            //    display: inline-block;
            // }
          }
          .child_information_edit_ruleForm_label_pic {
            width: 40px;
            height: 40px;
            margin-right: 55px;
            margin-left: 12px;
            border-radius: 25px;
          }
          .child_information_edit_ruleForm_label_sex,
          .child_information_edit_ruleForm_label_studentName,
          .child_information_edit_ruleForm_label_age,
          .child_information_edit_ruleForm_label_birthday,
          .child_information_edit_ruleForm_label_relationShip,
          .child_information_edit_ruleForm_label_idCard,
          .child_information_edit_ruleForm_label_school {
            margin-left: 8px;
            display: inline-block;
            vertical-align: middle;
          }
          .child_information_edit_ruleForm_label_relationShip {
            width: calc(100% - 68px);
          }
          .child_information_edit_ruleForm_label_studentName {
            width: 72px;
            // width:46.6%;
            margin-right: 20px;
            // margin-right:66px;
          }
          .child_information_edit_ruleForm_label_age {
            width: 40px;
            margin-right: 55px;
          }
          .child_information_edit_ruleForm_label_birthday {
            margin-right: 20px;
          }
          .child_information_edit_ruleForm_label_idCard {
            width: 127px;
            margin-right: 42px;
          }
          .child_information_edit_ruleForm_label_school {
            // width:156px;
            width: calc(100% - 62px);
            height: auto;
            white-space: pre-wrap;
            vertical-align: text-top;
          }
        }
      }
      .child_information_edit_ruleForm_default {
        .child_information_edit_ruleForm_default_inline {
          display: inline-block;
          margin-bottom: 22px;
          &.signs {
            width: 137px;
            margin-right: 18px;
          }
          &.nickName {
            width: 138px;
            margin-right: 18px;
            ::v-deep .el-form-item__content {
              width: 80px;
              margin-left: 56px;
            }
          }
          .child_information_edit_ruleForm_default_inline_signs {
            display: inline-block;
            width: 79px;
          }
        }
        .child_information_edit_ruleForm_default_block {
          .ruleForm_default_inline_genderNo {
            display: inline-block;
            width: 116px;
          }
          .ruleForm_default_inline_classNameNo {
            display: inline-block;
            width: 65px;
          }
          .ruleForm_default_inline_genderName {
            margin: 0 4px;
            color: #74410a;
            font-size: 12px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
          }
          .ruleForm_default_inline_className {
            margin-left: 4px;
            color: #74410a;
            font-size: 12px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
          }
          i {
            font-size: 12px;
            color: #ffd19f;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            font-style: normal;
          }
          .ruleForm_default_block_province,
          .ruleForm_default_block_city {
            position: relative;
            display: inline-block;
            // width:116px;
            width: 23.65%;
            // margin-right:18px;
            margin-right: 3.85%;
            .ruleForm_default_block_name {
              position: absolute;
              right: 7px;
            }
            ::v-deep .el-input__inner {
              padding-right: 24px;
            }
          }
          ::v-deep .el-input.is-disabled .el-input__inner {
            background-color: #d99649;
            border-color: #d99649;
            color: #fff6d4;
            cursor: pointer;
          }
          .ruleForm_default_block_county {
            position: relative;
            display: inline-block;
            // width:124px;
            width: 25.55%;
            .ruleForm_default_block_name {
              position: absolute;
              right: 7px;
            }
            ::v-deep .el-input__inner {
              padding-right: 42px;
            }
          }
          .ruleForm_default_block_personalSignature {
            // width:390px;
            width: 81%;
            ::v-deep .el-input__inner {
              &::placeholder {
                color: #fff6d4;
                font-size: 12px;
                font-weight: 400;
              }
            }
          }
        }
        ::v-deep .el-form-item__label {
          min-width: 48px;
          height: 25px;
          line-height: 25px;
          // vertical-align: top;
          // vertical-align: middle;
          // text-align: justify;
          // text-align-last: justify;
          color: #74410a;
          font-size: 12px;
          font-weight: 500;
          padding: 0;
          margin-right: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          .edit_ruleForm_label {
            display: flex;
            justify-content: space-between;
          }
        }
        ::v-deep .el-form-item__content {
          height: 25px;
          line-height: 25px;
          vertical-align: top;
        }
        ::v-deep .el-input__inner {
          height: 25px;
          line-height: 25px;
          background: #d99649;
          border-radius: 8px;
          font-size: 12px;
          color: #fff6d4;
          font-weight: 500;
          border-color: #d99649;
          box-shadow: 0 1px 0 0 #fff5d9, 0 -1px 1px 0 rgba(0, 0, 0, 0.5);
          &:focus {
            border-color: transparent;
          }
        }

        .child_information_edit_ruleForm_default_signs {
          width: 79px;
        }
      }
    }
    .ruleForm_block_btns {
      position: relative;
      height: 47px;
      .ruleForm_block_btns_add {
        display: block;
        width: 96px;
        height: 47px;
        margin-right: 20px;
        background: url("../../assets/images/children-file/btn1.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 42px;
        color: #74410a;
        font-size: 12px;
        font-weight: 500;
        font-family: PingFangSC-Regular, PingFang SC;
        position: absolute;
        right: 10px;
        top: 0;
      }
    }
    ::v-deep .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus,
    .el-message-box__input input.invalid,
    .el-message-box__input input.invalid:focus,
    .el-form-item.is-error ::v-deep .select_box_input_inner,
    .el-form-item.is-error ::v-deep .search_more_input_custom {
      border-color: #ff0000;
      box-shadow: 0 0 4px 0 #fff5d9, 0 -1px 1px 0 rgba(0, 0, 0, 0.5);
    }
    ::v-deep .el-form-item__error {
      color: #ff0000;
    }
  }
</style>
